import { RequestStatus } from '../../../shared/enums/request-status';

export const getIsRequestPending = (status): boolean =>
  status === RequestStatus.Pending;

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }

  return text;
};

export const formatPercentage = (percentage?: string): string => {
  if (!percentage) return '';

  const num = Number(percentage);
  if (Number.isNaN(num)) return '';

  return num % 1 === 0 ? `${parseInt(percentage, 10)}` : `${num.toFixed(2)}`;
};

export const formatNumberToKM = (num: number): string => {
  const absNum = Math.abs(num);

  let formatted;

  if (absNum >= 1_000_000_000) {
    formatted = `${(num / 1_000_000_000)?.toFixed(1)}B`;
  } else if (absNum >= 1_000_000) {
    formatted = `${(num / 1_000_000)?.toFixed(1)}M`;
  } else if (absNum >= 1_000) {
    formatted = `${(num / 1_000)?.toFixed(1)}K`;
  } else {
    return num?.toString();
  }

  return formatted?.replace(/\.0([KMB])$/, '$1');
};
